<template>
  <v-container>
    <h4>Job Information</h4>
    <v-row>
      <v-col
        cols="4"
        md="2"
      >
        <p>Job role:</p>
      </v-col>
      <v-col
        cols="8"
        md="10"
      >
        <p>
          <span
            v-for="(item, i) in job_list"
            :key="i"
          >
            <v-chip
              v-if="job_information.job_roles.includes(item.value)"
              class="ma-2"
            >
              {{ item.label }}
            </v-chip>
          </span>
        </p>
      </v-col>
      <v-col
        cols="4"
        md="2"
      >
        <p>Active:</p>
      </v-col>
      <v-col
        cols="8"
        md="4"
      >
        <p>{{ job_information.active ? 'Yes' : 'No' }}</p>
      </v-col>
      <v-col
        cols="4"
        md="2"
      >
        <p>Code:</p>
      </v-col>
      <v-col
        cols="8"
        md="4"
      >
        <p>{{ job_information.internal_code || '-' }}</p>
      </v-col>
      <v-col
        cols="4"
        md="2"
      >
        <p>Job live-in/live-out:</p>
      </v-col>
      <v-col
        cols="8"
        md="4"
      >
        <p
          v-if="job_information.job_live"
        >
          {{ job_information.job_live }}
        </p>
        <p
          v-else
        >
          -
        </p>
      </v-col>
      <v-col
        cols="4"
        md="2"
      >
        <p>Job type:</p>
      </v-col>
      <v-col
        cols="8"
        md="4"
      >
        <p
          v-if="job_information.job_type"
        >
          {{ job_information.job_type }}
        </p>
        <p
          v-else
        >
          -
        </p>
      </v-col>
      <v-col
        cols="4"
        md="2"
      >
        <p>Expected salary:</p>
      </v-col>
      <v-col
        cols="8"
        md="4"
      >
        <p>{{ job_information.expected_salary || '-' }}</p>
      </v-col>
      <v-col
        cols="4"
        md="2"
      >
        <p>Job location:</p>
      </v-col>
      <v-col
        cols="8"
        md="4"
      >
        <p
          v-if="job_information.job_location == 'Bangkok'"
        >
          Bangkok
        </p>
        <p
          v-else-if="job_information.job_location == 'Nonthaburi'"
        >
          Nonthaburi
        </p>
        <p
          v-else-if="job_information.job_location == 'Cambodia'"
        >
          Phnom Penh, Cambodia
        </p>
        <p
          v-else-if="job_information.job_location == 'Laos'"
        >
          Vientiane, Laos
        </p>
        <p
          v-else
        >
          -
        </p>
      </v-col>
      <v-col
        cols="12"
        md="6"
      >
        <v-spacer></v-spacer>
      </v-col>
      <v-col
        cols="4"
        md="2"
      >
        <p>Remark:</p>
      </v-col>
      <v-col
        cols="8"
        md="4"
      >
        <p>{{ job_information.remark || '-' }}</p>
      </v-col>
      <v-col
        cols="4"
        md="2"
      >
        <p>Comment:</p>
      </v-col>
      <v-col
        cols="8"
        md="4"
      >
        <p>{{ job_information.comment || '-' }}</p>
      </v-col>
      <v-col
        cols="4"
        md="2"
      >
        <p>Bank name:</p>
      </v-col>
      <v-col
        cols="8"
        md="4"
      >
        <p>{{ job_information.bank_name || '-' }}</p>
      </v-col>
      <v-col
        cols="4"
        md="2"
      >
        <p>Bank account name:</p>
      </v-col>
      <v-col
        cols="8"
        md="4"
      >
        <p>{{ job_information.bank_account_name || '-' }}</p>
      </v-col>
      <v-col
        cols="4"
        md="2"
      >
        <p>Bank account number:</p>
      </v-col>
      <v-col
        cols="8"
        md="4"
      >
        <p>{{ job_information.bank_account_number || '-' }}</p>
      </v-col>
      <v-col
        cols="4"
        md="2"
      >
        <p>Reference person:</p>
      </v-col>
      <v-col
        cols="8"
        md="4"
      >
        <p>{{ job_information.reference_person || '-' }}</p>
      </v-col>
      <v-col
        cols="4"
        md="2"
      >
        <p>Reference contact:</p>
      </v-col>
      <v-col
        cols="8"
        md="4"
      >
        <p>{{ job_information.reference_contact || '-' }}</p>
      </v-col>
    </v-row>
    <v-divider></v-divider>
  </v-container>
</template>

<script>
export default {
  name: 'JobInformation',
  components: { },
  props: ['job_information'],
  data: () => ({
    job_role_list: [],
    job_list: [
      { label: 'Maid', value: 'maid' },
      { label: 'Nanny', value: 'nanny' },
      { label: 'Elder', value: 'elder' },
      { label: 'Cook', value: 'cook' },
      { label: 'Pet', value: 'pet' },
      { label: 'Premium nanny', value: 'premium' },
      { label: 'Restaurant', value: 'restaurant' },
      { label: 'Driver', value: 'driver' },
    ],
  }),
  mounted () { },
  methods: { }
}
</script>

<style scoped>
</style>